import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { forgotPassword } from "../../../services/auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useForgotPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const forgotFormik = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit: () => {},
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Invalid Email"
        ),
    }),
  });

  const { values } = forgotFormik;

  const handleSendLink = async () => {
    setIsLoading(true);
    const response: any = await forgotPassword(values.email);
    if (response.statusCode === 200 && response.isSuccess) {
      setIsLoading(false);
      toast.success(response.message);
      navigate("/");
    } else {
      toast.error(response.message);
      setIsLoading(false);
    }
  };

  return {
    forgotFormik,
    handleSendLink,
    isLoading,
  };
};
